import { useState, useEffect } from "react";
import { AnimatePresence } from "framer-motion";
import "@/App.css";
import { Navbar } from "@/components/Navbar";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { ServiceTimes } from "@/components/ServiceTimes";
import { PropheticFocus } from "@/components/PropheticFocus";
import { Announcements } from "@/components/Announcements";
import { GivingBanner } from "@/components/GivingBanner";
import { ChatWidget } from "@/components/ChatWidget";
import { TestimonyWall } from "@/components/TestimonyWall";
import { InstagramFeed } from "@/components/InstagramFeed";
import { EventsSection } from "@/components/EventsSection";
import { PrayerRequest } from "@/components/PrayerRequest";
import { Footer } from "@/components/Footer";
import { AdminPanel } from "@/components/AdminPanel";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

function App() {
  const [showAdmin, setShowAdmin] = useState(false);

  useEffect(() => {
    const seedData = async () => {
      try {
        await Promise.all([
          axios.post(`${API}/seed-events`),
          axios.post(`${API}/seed-gallery`),
        ]);
      } catch (err) {
        // Silently fail - data may already exist
      }
    };
    seedData();
  }, []);

  // Set custom favicon after mount (overrides platform default)
  useEffect(() => {
    const setFavicon = () => {
      const existing = document.querySelectorAll('link[rel*="icon"]');
      existing.forEach(el => el.remove());
      const link = document.createElement('link');
      link.rel = 'icon';
      link.type = 'image/png';
      link.href = '/favicon-32.png';
      document.head.appendChild(link);
    };
    const timer = setTimeout(setFavicon, 1000);
    const interval = setInterval(setFavicon, 3000);
    return () => { clearTimeout(timer); clearInterval(interval); };
  }, []);

  return (
    <div className="min-h-screen">
      <AnimatePresence mode="wait">
        {showAdmin ? (
          <AdminPanel key="admin" onClose={() => setShowAdmin(false)} />
        ) : (
          <div key="main">
            <Navbar />
            <ChatWidget />
            <Hero />
            <GivingBanner />
            <Announcements />
            <About />
            <PropheticFocus />
            <ServiceTimes />
            <EventsSection />
            <InstagramFeed />
            <TestimonyWall />
            <PrayerRequest />
            <Footer onAdminClick={() => setShowAdmin(true)} />
          </div>
        )}
      </AnimatePresence>
    </div>
  );
}

export default App;
